import { EmployeeDetailTab } from "components/non-employee/employee-detail/employee-detail-tab/EmployeeDetailTab";
import { useEffect, useMemo, useState } from "react";
import { API_NON_EMPLOYEE } from "services/apiNonEmployee";
import { useFetch } from "services/useFetch";
import { capitalize } from "utils/utils";
import { AdditionalInfoTabContainer } from "./AdditionalInfoTabContainer";
import { BankInfoTabContainer } from "./BankInfoTabContainer";
import { JobTitleTabContainer } from "./JobTitleTabContainer";
import { PersonalInfoTabContainer } from "./PersonalInfoTabContainer";
import {ChangePasswordTabContainer} from "./ChangePasswordTabContainer";

export const EmployeeDetailTabContainer = () => {
    const { data: dataConstantsEmployee } = useFetch(API_NON_EMPLOYEE.LIST_CONSTANTS_EMPLOYEE, {}, { isFetching: true })

    const { optionsEmployeeType, optionsGrades, optionsPersonalDocumentType, optionsGender, optionsReligions, optionsMaritalStatus, optionsBloodType } = useMemo(() => {
        const mapOptions = (dataList) => {
            if (!dataList || dataList?.length === 0) return []
            return dataList?.map((item) => ({
                label: capitalize(item?.replace('-', ' ')),
                value: item,
            }))
        }
        const optionsEmployeeType = mapOptions(dataConstantsEmployee?.data?.type)
        const optionsGrades = mapOptions(dataConstantsEmployee?.data?.grades)
        const optionsPersonalDocumentType = mapOptions(dataConstantsEmployee?.data?.personalDocumentType)
        const optionsGender = mapOptions(dataConstantsEmployee?.data?.gender)
        const optionsReligions = mapOptions(dataConstantsEmployee?.data?.religions)
        const optionsMaritalStatus = mapOptions(dataConstantsEmployee?.data?.maritalStatus)
        const optionsBloodType = mapOptions(dataConstantsEmployee?.data?.bloodType)
        return {
            optionsEmployeeType,
            optionsGrades,
            optionsPersonalDocumentType,
            optionsGender,
            optionsReligions,
            optionsMaritalStatus,
            optionsBloodType,
        }

    }, [dataConstantsEmployee?.data])

    const employeeDetailTabList = useMemo(() => [
        {
            label: 'Informasi Pribadi',
            key: 'personal_detail',
            component: <PersonalInfoTabContainer optionsEmployeeType={optionsEmployeeType} />
        }, {
            label: 'Informasi Rekening',
            key: 'bank_info',
            component: <BankInfoTabContainer />
        }, {
            label: 'Job Title',
            key: 'job_title_employees',
            component: <JobTitleTabContainer />
        }, {
            label: 'Informasi Tambahan',
            key: 'additional_info',
            component: <AdditionalInfoTabContainer options={{
                optionsGrades,
                optionsPersonalDocumentType,
                optionsGender,
                optionsReligions,
                optionsMaritalStatus,
                optionsBloodType,
            }} />
        }, {
            label: 'Ubah Password',
            key: 'change_password',
            component: <ChangePasswordTabContainer />,
        }
    ], [optionsEmployeeType, optionsGrades, optionsPersonalDocumentType, optionsGender, optionsReligions, optionsMaritalStatus, optionsBloodType])

    const [tabSelected, setTableSelected] = useState(employeeDetailTabList[0])

    useEffect(() => {
        const updatedTab = employeeDetailTabList.find(tab => tab.key === tabSelected?.key)
        if (updatedTab) {
            setTableSelected(updatedTab)
        }
    }, [employeeDetailTabList])

    const onChangeTab = (tab) => {
        setTableSelected(tab)
    }


    return (
        <EmployeeDetailTab tabSelected={tabSelected} employeeDetailTabList={employeeDetailTabList} onChangeTab={onChangeTab} />
    )
}
